import { jwtDecode } from 'jwt-decode'
import store from '@/store'

const removeDataTableStates = () => Object.keys(sessionStorage)
                                        .filter(k => /^dt-state/.test(k))
                                        .forEach(k => sessionStorage.removeItem(k))

const removeFiltersList = () => sessionStorage.removeItem('filtersIndexGrid')

export default [
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "Login" */ '../views/Login.vue')
    },
    {
        path: '/request-password',
        name: 'RequestPassword',
        component: () => import(/* webpackChunkName: "RequestPassword" */ '../views/RequestPassword.vue')
    },
    {
        path: '/forgot-pass/:token',
        name: 'forgotPass',
        component: () => import(/* webpackChunkName: "ForgotPass" */ '../views/ForgotPass.vue')
    },
    {
        path: '/registro-docente',
        name: 'registroDocente',
        component: () => import(/* webpackChunkName: "TeacherRegistration" */ '../views/PublicRegistration/Teacher/TeacherRegistration.vue')
    },
    {
        path: '/registro-docente/datos/:id_center_jaes',
        name: 'registroDocenteDatos',
        component: () => import(/* webpackChunkName: "TeacherRegistrationData" */ '../views/PublicRegistration/Teacher/TeacherRegistrationData.vue')
    },
    {
        path: '/registro-estudiante',
        name: 'registroEstudiante',
        component: () => import(/* webpackChunkName: "StudentRegistration" */ '../views/PublicRegistration/Student/StudentRegistration.vue')
    },
    {
        path: '/registro-estudiante/datos/:code_for_students',
        name: 'registroEstudianteDatos',
        component: () => import(/* webpackChunkName: "StudentRegistrationData" */ '../views/PublicRegistration/Student/StudentRegistrationData.vue')
    },
    {
        path: '/registro-voluntario',
        name: 'registroVoluntario',
        component: () => import(/* webpackChunkName: "VolunteerRegistration" */ '../views/PublicRegistration/Volunteer/VolunteerRegistration.vue')
    },
    {
        path: '/registro-voluntario/datos/:code_for_company',
        name: 'registroVoluntarioDatos',
        component: () => import(/* webpackChunkName: "VolunteerRegistrationData" */ '../views/PublicRegistration/Volunteer/VolunteerRegistrationData.vue')
    },
    {
        path: '/registro-confirmacion',
        name: 'registroConfirmacion',
        component: () => import(/* webpackChunkName: "PublicRegistrationConfirmation" */ '../views/PublicRegistration/RegistrationConfirmation.vue')
    },
    {
        path: '/',
        name: 'home',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue'),
        beforeEnter: async (to, from, next) => {
            try {
                jwtDecode(store.state.auth.token)
                return next()
            } catch(e) {
                store.commit('auth/logout', null, { root: true })
                return next('/login')
            }
        },
        children: [
            {
                path: '',
                name: 'dashboard',
                meta: { subject: 'dashboard' },
                component: () => import(/* webpackChunkName: "Dashboard" */ '../views/Dashboard.vue')
            },
            {
                path: 'my-profile',
                name: 'myProfile',
                meta: {
                    subject: 'detailUser',
                    authorize: ['teacher', 'student', 'mentor', 'jury', 'mentor_jury']
                },
                component: () => import(/* webpackChunkName: "MyProfile" */ '../views/Profiles/Profile.vue')
            },
            {
                path: 'material-educativo',
                name: 'educationalMaterial',
                meta: { subject: 'dreamshaper.material', authorize: ['admin', 'teacher'] },
                component: () => import(/* webpackChunkName: "EducationalMaterial" */ '../views/DreamShaper/MaterialEducativo.vue')
            },
            {
                path: 'teachers',
                name: 'teachers',
                meta: { subject: 'teacher', authorize: ['admin'] },
                component: () => import(/* webpackChunkName: "Teachers" */ '../views/Teachers/Teachers.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'teacher') removeFiltersList()
                    return next()
                }
            },
            {
                path: 'teachers/:id',
                name: 'teacher',
                meta: { subject: 'teacher', authorize: ['admin'] },
                component: () => import(/* webpackChunkName: "Teacher" */ '../views/Teachers/Teacher.vue'),
            },
            {
                path: 'volunteers',
                name: 'volunteers',
                meta: { subject: 'volunteer', authorize: ['admin'] },
                component: () => import(/* webpackChunkName: "Volunteers" */ '../views/Volunteers/Volunteers.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'volunteer') removeFiltersList()
                    return next()
                }
            },
            {
                path: 'volunteers/:id',
                name: 'volunteer',
                meta: { subject: 'volunteer', authorize: ['admin'] },
                component: () => import(/* webpackChunkName: "Volunteer" */ '../views/Volunteers/Volunteer.vue'),
            },
            {
                path: 'students',
                name: 'students',
                meta: { subject: 'student', authorize: ['admin', 'teacher'] },
                component: () => import(/* webpackChunkName: "Students" */ '../views/Students/Students.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'student') removeFiltersList()
                    return next()
                }
            },
            {
                path: 'students/:id',
                name: 'student',
                meta: { subject: 'student', authorize: ['admin', 'teacher'] },
                component: () => import(/* webpackChunkName: "Student" */ '../views/Students/Student.vue'),
                beforeEnter: (to, from, next) => {
                    if (to.params.id === 'new' && store.getters['auth/getCurrentUser']?.role !== 'admin') {
                        return next({ name: 'students' })
                    }

                    return next()
                }
            },
            {
                path: 'classes',
                name: 'classes',
                meta: { subject: 'class', authorize: ['admin', 'teacher'] },
                component: () => import(/* webpackChunkName: "Classes" */ '../views/Classes/Classes.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'class') removeFiltersList()
                    return next()
                }
            },
            {
                path: 'classes/:id',
                name: 'class',
                meta: { subject: 'class', authorize: ['admin', 'teacher'] },
                component: () => import(/* webpackChunkName: "Class" */ '../views/Classes/Class.vue'),
            },
            {
                path: 'matching',
                name: 'matching',
                meta: { subject: 'matching', authorize: ['admin', 'mentor', 'jury', 'mentor_jury'] },
                component: () => import(/* webpackChunkName: "Matching" */ '../views/Matching/Matching.vue')
            },
            {
                path: 'matching-jurado',
                name: 'matchingJuryGroup',
                meta: { subject: 'matching.jury_group', authorize: ['admin'] },
                component: () => import(/* webpackChunkName: "MatchingJuryGroup" */ '../views/MatchingJuryGroup/MatchingJuryGroup.vue'),
                beforeEnter: (to, from, next) => {
                    removeFiltersList()
                    return next()
                }
            },
            {
                path: 'ranking',
                name: 'ranking',
                meta: { subject: 'ranking', authorize: ['admin', 'teacher', 'student', 'mentor', 'jury', 'mentor_jury'] },
                component: () => import(/* webpackChunkName: "Ranking" */ '../views/Ranking/Ranking.vue')
            },
            {
                path: 'ranking/:id_deliverable',
                name: 'rankingDeliverable',
                meta: { subject: 'ranking', authorize: ['admin', 'teacher', 'student', 'mentor', 'jury', 'mentor_jury'] },
                component: () => import(/* webpackChunkName: "RankingDeliverable" */ '../views/Ranking/RankingDeliverable.vue')
            },
            {
                path: 'my-notifications',
                name: 'myNotifications',
                meta: { subject: 'myNotification', authorize: ['admin', 'teacher', 'student', 'mentor', 'jury', 'mentor_jury'] },
                component: () => import(/* webpackChunkName: "MyNotifications" */ '../views/Notifications/MyNotifications.vue')
            },
            {
                path: 'my-notifications/:id_notification',
                name: 'myNotification',
                meta: { subject: 'myNotification', authorize: ['admin', 'teacher', 'student', 'mentor', 'jury', 'mentor_jury'] },
                component: () => import(/* webpackChunkName: "MyNotification" */ '../views/Notifications/MyNotification.vue')
            },
            {
                path: 'my-snack-chat',
                name: 'mySnackChats',
                meta: { subject: 'snack_chat.feed', authorize: ['teacher', 'student', 'mentor', 'jury', 'mentor_jury','admin'] },
                component: () => import(/* webpackChunkName: "MySnackChats" */ '../views/SnackChat/MySnackChats.vue')
            },
            {
                path: 'my-snack-chat/:id',
                name: 'mySnackChat',
                meta: { subject: 'snack_chat.feed', authorize: ['teacher', 'student', 'mentor', 'jury', 'mentor_jury', 'admin'] },
                component: () => import(/* webpackChunkName: "MySnackChat" */ '../views/SnackChat/MySnackChat.vue')
            },
            {
                path: 'my-snack-chat/:id/questions/:questionId',
                name: 'mySnackChatQuestionThread',
                meta: { subject: 'snack_chat.feed', authorize: ['teacher', 'student', 'mentor', 'jury', 'mentor_jury', 'admin'] },
                component: () => import(/* webpackChunkName: "MySnackChatQuestionThread" */ '../views/SnackChat/MySnackChatQuestionThread.vue')
            },
            {
                path: 'snack-chat',
                name: 'snackChats',
                meta: { subject: 'snack_chat', authorize: ['admin', 'mentor', 'jury', 'mentor_jury'] },
                component: () => import(/* webpackChunkName: "SnackChats" */ '../views/SnackChat/SnackChats.vue')
            },
            {
                path: 'snack-chat/new',
                name: 'snackChatNew',
                meta: { subject: 'snack_chat', authorize: ['admin'] },
                component: () => import(/* webpackChunkName: "SnackChat" */ '../views/SnackChat/SnackChat.vue')
            },
            {
                path: 'snack-chat/:id',
                name: 'snackChat',
                meta: { subject: 'snack_chat', authorize: ['admin', 'mentor', 'jury', 'mentor_jury'] },
                component: () => import(/* webpackChunkName: "SnackChat" */ '../views/SnackChat/SnackChat.vue')
            },
            {
                path: 'my-groups',
                name: 'myGroups',
                meta: { subject: 'matching.my_mentorships', authorize: ['mentor', 'mentor_jury'] },
                component: () => import(/* webpackChunkName: "MatchingMyGroups" */ '../views/Matching/MyGroups.vue')
            },
            {
                path: 'my-evaluations',
                name: 'myEvaluations',
                meta: { subject: 'matching.my_evaluations', authorize: ['jury', 'mentor_jury'] },
                component: () => import(/* webpackChunkName: "MatchingMyEvaluations" */ '../views/Evaluation/MyEvaluations.vue')
            },
            {
                path: 'my-evaluations/:id_group_volunteer_jury',
                name: 'myEvaluation',
                meta: { subject: 'matching.evaluation', authorize: ['admin', 'jury', 'mentor_jury'] },
                component: () => import(/* webpackChunkName: "myEvaluation" */ '../views/Evaluation/Evaluation.vue')
            },
            {
                path: 'group-teams',
                name: 'groupTeams',
                meta: { subject: 'group_team', authorize: ['admin', 'teacher', 'student'] },
                component: () => import(/* webpackChunkName: "GroupTeams" */ '../views/GroupTeams/GroupTeams.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'groupTeam') removeFiltersList()
                    return next()
                }
            },
            {
                path: 'group-teams/:id',
                name: 'groupTeam',
                meta: { subject: 'group_team', authorize: ['admin', 'teacher', 'student', 'mentor', 'mentor_jury'] },
                component: () => import(/* webpackChunkName: "GroupTeam" */ '../views/GroupTeams/GroupTeam.vue'),
            },
            {
                path: 'group-teams/:id/conversations/:conversationId',
                name: 'groupTeamConversation',
                meta: { subject: 'group_team_conversation', authorize: ['admin', 'teacher', 'student', 'mentor', 'mentor_jury'] },
                component: () => import(/* webpackChunkName: "GroupTeamConversation" */ '../views/GroupTeams/GroupTeamConversation.vue')
            },
            {
                path: 'documents',
                name: 'documents',
                meta: { subject: 'documents', authorize: ['admin', 'teacher', 'student', 'mentor', 'jury', 'mentor_jury'] },
                component: () => import(/* webpackChunkName: "Documents" */ '../views/Documents/Documents.vue')
            },
            {
                path: 'deliverables',
                name: 'deliverables',
                meta: { subject: 'deliverable', authorize: ['admin'] },
                component: () => import(/* webpackChunkName: "Deliverables" */ '../views/Deliverables/Deliverables.vue'),
                beforeEnter: (to, from, next) => {
                    if (from.name !== 'deliverable') removeFiltersList()
                    return next()
                }
            },
            {
                path: '/active-deliverables',
                name: 'entregables',
                meta: { subject: 'deliverable', authorize: ['admin', 'teacher', 'student', 'mentor', 'mentor_jury'] },
                component: () => import(/* webpackChunkName: "ActiveDeliverables" */ '../views/PublicDeliverables/ActiveDeliverables.vue')
            },
            {
                path: '/active-deliverables/:id/:id_group_team',
                name: 'entregable',
                meta: { subject: 'deliverable', authorize: ['admin', 'teacher', 'student', 'mentor', 'mentor_jury'] },
                component: () => import(/* webpackChunkName: "DeliverablePreview" */ '../views/PublicDeliverables/DeliverablePreview.vue')
            },
            {
                path: 'deliverables/:id',
                name: 'deliverable',
                meta: { subject: 'deliverable', authorize: ['admin'] },
                component: () => import(/* webpackChunkName: "Deliverable" */ '../views/Deliverables/Deliverable.vue'),
            },
            {
                path: 'admin',
                children: [
                    {
                        path: 'centers',
                        name: 'centers',
                        meta: { subject: 'admin.center', authorize: ['admin'] },
                        component: () => import(/* webpackChunkName: "Centers" */ '../views/Admin/Center/Centers.vue'),
                        beforeEnter: (to, from, next) => {
                            if (from.name !== 'center') removeFiltersList()
                            return next()
                        }
                    },
                    {
                        path: 'centers/:id',
                        name: 'center',
                        meta: { subject: 'admin.center', authorize: ['admin'] },
                        component: () => import(/* webpackChunkName: "Center" */ '../views/Admin/Center/Center.vue'),
                    },
                    {
                        path: 'companies',
                        name: 'companies',
                        meta: { subject: 'admin.company', authorize: ['admin'] },
                        component: () => import(/* webpackChunkName: "Companies" */ '../views/Admin/Company/Companies.vue'),
                        beforeEnter: (to, from, next) => {
                            if (from.name !== 'company') removeFiltersList()
                            return next()
                        }
                    },
                    {
                        path: 'companies/:id',
                        name: 'company',
                        meta: { subject: 'admin.company', authorize: ['admin'] },
                        component: () => import(/* webpackChunkName: "Company" */ '../views/Admin/Company/Company.vue'),
                    },
                    {
                        path: 'block-matching',
                        name: 'blockMatchings',
                        meta: { subject: 'admin.block_matching', authorize: ['admin'] },
                        component: () => import(/* webpackChunkName: "BlockMatchings" */ '../views/Admin/BlockMatching/BlockMatchings.vue'),
                        beforeEnter: (to, from, next) => {
                            if (from.name !== 'blockMatching') removeFiltersList()
                            return next()
                        }
                    },
                    {
                        path: 'block-matching/new',
                        name: 'blockMatching',
                        meta: { subject: 'admin.block_matching', authorize: ['admin'] },
                        component: () => import(/* webpackChunkName: "BlockMatching" */ '../views/Admin/BlockMatching/BlockMatching.vue'),
                    },
                    {
                        path: 'skip-matching',
                        name: 'skipMatchings',
                        meta: { subject: 'admin.skip_matching', authorize: ['admin'] },
                        component: () => import(/* webpackChunkName: "SkipMatchings" */ '../views/Admin/SkipMatching/SkipMatchings.vue'),
                        beforeEnter: (to, from, next) => {
                            if (from.name !== 'skipMatchings') removeFiltersList()
                            return next()
                        }
                    },
                    {
                        path: 'masters',
                        name: 'masters',
                        meta: { subject: 'admin.master', authorize: ['admin'] },
                        component: () => import(/* webpackChunkName: "Masters" */ '../views/Admin/Masters/Index.vue')
                    },
                    {
                        path: 'masters/center-types',
                        name: 'centerTypes',
                        meta: { subject: 'admin.center_type', authorize: ['admin'] },
                        component: () => import(/* webpackChunkName: "CenterTypes" */ '../views/Admin/Masters/CenterTypes.vue')
                    },
                    {
                        path: 'masters/natures',
                        name: 'natures',
                        meta: { subject: 'admin.nature', authorize: ['admin'] },
                        component: () => import(/* webpackChunkName: "Natures" */ '../views/Admin/Masters/Natures.vue')
                    },
                    {
                        path: 'masters/evaluation-criteria',
                        name: 'evaluationCriteria',
                        meta: { subject: 'admin.evaluation_criteria', authorize: ['admin'] },
                        component: () => import(/* webpackChunkName: "EvaluationCriteria" */ '../views/Admin/Masters/EvaluationCriteria.vue')
                    },
                    {
                        path: 'masters/custom-lists',
                        name: 'customLists',
                        meta: { subject: 'admin.custom_list', authorize: ['admin'] },
                        component: () => import(/* webpackChunkName: "CustomLists" */ '../views/Admin/Masters/CustomLists.vue'),
                        beforeEnter: (to, from, next) => {
                            if (from.name !== 'customList') removeFiltersList()
                            return next()
                        }
                    },
                    {
                        path: 'masters/custom-lists/:id',
                        name: 'customList',
                        meta: { subject: 'admin.custom_list', authorize: ['admin'] },
                        component: () => import(/* webpackChunkName: "CustomList" */ '../views/Admin/Masters/CustomList.vue')
                    },
                    {
                        path: 'guides',
                        name: 'guides',
                        meta: { subject: 'admin.guide', authorize: ['admin'] },
                        component: () => import(/* webpackChunkName: "Guides" */ '../views/Admin/Guide/Guides.vue'),
                        beforeEnter: (to, from, next) => {
                            if (from.name !== 'guide') removeFiltersList()
                            return next()
                        }
                    },
                    {
                        path: 'guides/:id',
                        name: 'guide',
                        meta: { subject: 'admin.guide', authorize: ['admin'] },
                        component: () => import(/* webpackChunkName: "Guide" */ '../views/Admin/Guide/Guide.vue'),
                    },
                    {
                        path: 'notifications',
                        name: 'notifications',
                        meta: { subject: 'admin.notifications', authorize: ['admin'] },
                        component: () => import(/* webpackChunkName: "Notifications" */ '../views/Admin/Notification/Notifications.vue'),
                        beforeEnter: (to, from, next) => {
                            if (from.name !== 'notification') removeFiltersList()
                            return next()
                        }
                    },
                    {
                        path: 'notifications/:id',
                        name: 'notification',
                        meta: { subject: 'admin.notifications', authorize: ['admin'] },
                        component: () => import(/* webpackChunkName: "Notification" */ '../views/Admin/Notification/Notification.vue'),
                    },
                    {
                        path: 'reporting',
                        meta: { subject: 'admin.reporting', authorize: ['admin'] },
                        children: [
                            {
                                path: 'reportes',
                                name: 'reportes',
                                meta: { subject: 'admin.reporting.reports', authorize: ['admin'] },
                                component: () => import(/* webpackChunkName: "ReportingReports" */ '../views/Reporting/Reports.vue')
                            },
                            {
                                path: 'centros',
                                name: 'reportingCenters',
                                meta: { subject: 'admin.reporting.centers', authorize: ['admin'] },
                                component: () => import(/* webpackChunkName: "ReportingCenters" */ '../views/Reporting/Centers.vue')
                            },
                            {
                                path: 'docentes',
                                name: 'reportingTeachers',
                                meta: { subject: 'admin.reporting.teachers', authorize: ['admin'] },
                                component: () => import(/* webpackChunkName: "ReportingTeachers" */ '../views/Reporting/Teachers.vue')
                            },
                            {
                                path: 'clases',
                                name: 'reportingClasses',
                                meta: { subject: 'admin.reporting.classes', authorize: ['admin'] },
                                component: () => import(/* webpackChunkName: "ReportingClasses" */ '../views/Reporting/Classes.vue')
                            },
                            {
                                path: 'estudiantes',
                                name: 'reportingStudents',
                                meta: { subject: 'admin.reporting.students', authorize: ['admin'] },
                                component: () => import(/* webpackChunkName: "ReportingStudents" */ '../views/Reporting/Students.vue')
                            },
                            {
                                path: 'equipos',
                                name: 'reportingTeams',
                                meta: { subject: 'admin.reporting.teams', authorize: ['admin'] },
                                component: () => import(/* webpackChunkName: "ReportingTeams" */ '../views/Reporting/Teams.vue')
                            },
                            {
                                path: 'entregables',
                                name: 'reportingDeliverables',
                                meta: { subject: 'admin.reporting.deliverables', authorize: ['admin'] },
                                component: () => import(/* webpackChunkName: "ReportingDeliverables" */ '../views/Reporting/Deliverables.vue')
                            },
                            {
                                path: 'voluntarios',
                                name: 'reportingVolunteers',
                                meta: { subject: 'admin.reporting.volunteers', authorize: ['admin'] },
                                component: () => import(/* webpackChunkName: "ReportingVolunteers" */ '../views/Reporting/Volunteers.vue')
                            },
                            {
                                path: 'jurados',
                                name: 'reportingJurors',
                                meta: { subject: 'admin.reporting.jurors', authorize: ['admin'] },
                                component: () => import(/* webpackChunkName: "ReportingJurors" */ '../views/Reporting/Jurors.vue')
                            },
                            {
                                path: 'mentores',
                                name: 'reportingMentors',
                                meta: { subject: 'admin.reporting.mentors', authorize: ['admin'] },
                                component: () => import(/* webpackChunkName: "ReportingMentors" */ '../views/Reporting/Mentors.vue')
                            }
                        ]
                    },
                    {
                        path: 'tags',
                        name: 'tags',
                        meta: { subject: 'admin.tag', authorize: ['admin'] },
                        component: () => import(/* webpackChunkName: "Tags" */ '../views/Admin/Tag/Tags.vue'),
                        beforeEnter: (to, from, next) => {
                            if (from.name !== 'tag') removeFiltersList()
                            return next()
                        }
                    },
                    {
                        path: 'tags/:id',
                        name: 'tag',
                        meta: { subject: 'admin.tag', authorize: ['admin'] },
                        component: () => import(/* webpackChunkName: "Tag" */ '../views/Admin/Tag/Tag.vue'),
                    },
                    {
                        path: 'users',
                        name: 'users',
                        meta: { subject: 'admin.user' },
                        component: () => import(/* webpackChunkName: "Users" */ '../views/Admin/User/Users.vue'),
                        beforeEnter: (to, from, next) => {
                            if (from.name !== 'user') removeFiltersList()
                            return next()
                        }
                    },
                    {
                        path: 'users/:id',
                        name: 'user',
                        meta: { subject: 'admin.user' },
                        component: () => import(/* webpackChunkName: "User" */ '../views/Admin/User/User.vue'),
                    },
                    {
                        path: 'delete-platform',
                        name: 'deletePlatform',
                        meta: { subject: 'admin.delete_platform', authorize: ['admin'] },
                        component: () => import(/* webpackChunkName: "DeletePlatform" */ '../views/Admin/DeletePlatform/DeletePlatform.vue')
                    }
                ]
            }

        ]
    },
    { path: "/:pathMatch(.*)*", redirect: '/' }
]
